import { isArray } from 'util';
import { UserSubactivity } from '../user-subactivity';
import { UserActivityBuilder } from './user-activity.builder';

export class UserSubactivityBuilder {
  static fromJson(json) {
    return (json)
      ? new UserSubactivity(
        json.hash,
        json.name,
        UserActivityBuilder.fromJson(json.userActivity)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(UserSubactivityBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/user-subactivity.builder.ts